import { canUseWindow } from 'utils/browserEnvironment'
import { actionTypes } from 'actions/actionTypes'
import fbSettings from 'config/template'
import {
  getYourFriendFirstBoxOffer,
  getYourFriendFirstMonthOffer,
  getDiscountDurationFormatted,
  getYourFriendSecondBoxOffer,
} from 'selectors/rafOffer'

export const SOCIAL_TYPES = {
  email: 'Email',
  messenger: 'Messenger',
  facebook: 'Facebook',
  link: 'Link',
  text: 'Text Message',
  whatsapp: 'Whatsapp',
}

export const SHARE_TITLE = "Here's the link to use my Gousto discount 👇"

// Callers gate on isShareableOffer, which guarantees every value below is present.
export const getMessage = (offer) => {
  const firstBoxOffer = getYourFriendFirstBoxOffer(offer)
  const secondBoxOffer = getYourFriendSecondBoxOffer(offer)
  const firstMonthOffer = getYourFriendFirstMonthOffer(offer)
  const discountDuration = getDiscountDurationFormatted(offer)

  return `Use my code to get ${firstBoxOffer} off your first box (plus ${secondBoxOffer} off your second box and ${firstMonthOffer} off all other boxes in your first ${discountDuration}) and meet the new Gousto - faster and tastier than ever.`
}

export const getReferralLink = (referralCode, userFirstName = '', UTM = '') => {
  const userNameString = userFirstName ? `&name=${userFirstName}` : ''

  return `https://www.gousto.co.uk/raf/?promo_code=${referralCode}${userNameString}${UTM}`
}

export const getFacebookReferralLink = (
  referralCode,
  userFirstName,
  trackingReferFriendSocialSharing,
  trackUserFreeFoodLinkShare,
) => {
  trackingReferFriendSocialSharing(actionTypes.REFER_FRIEND_LINK_SHARE, 'ReferFriendLink Share', SOCIAL_TYPES.facebook)
  trackUserFreeFoodLinkShare({ target: SOCIAL_TYPES.facebook })

  const facebookUTM = '&utm_source=facebook&utm_medium=sharebutton_raf_page&utm_campaign=raf_facebook_share'
  const referralLink = getReferralLink(referralCode, userFirstName, facebookUTM)

  if (canUseWindow() && window.FB) {
    window.FB.ui({
      method: 'share',
      mobile_iframe: true,
      href: referralLink,
      redirect_uri: referralLink,
    })
  }
}

export const getMessengerReferralLink = (
  referralCode,
  userFirstName,
  trackingReferFriendSocialSharing,
  device,
  trackUserFreeFoodLinkShare,
) => {
  trackingReferFriendSocialSharing(actionTypes.REFER_FRIEND_LINK_SHARE, 'ReferFriendLink Share', SOCIAL_TYPES.messenger)
  trackUserFreeFoodLinkShare({ target: SOCIAL_TYPES.messenger })

  const messengerUTM = '&utm_source=messenger&utm_medium=sharebutton_raf_page&utm_campaign=raf_messenger_share'
  const referralLink = getReferralLink(referralCode, userFirstName, messengerUTM)

  if (canUseWindow()) {
    if (device === 'desktop' || device === 'tablet') {
      window.FB.ui({
        method: 'send',
        mobile_iframe: true,
        link: referralLink,
        redirect_uri: referralLink,
      })
    } else {
      const { fbAppID } = fbSettings.head
      const shareurl = `https://www.facebook.com/dialog/share?app_id=${fbAppID}&display=popup&href=${referralLink}&redirect_uri=${referralLink}`

      window.open(shareurl)
    }
  }
}

export const getWhatsappReferralLink = (
  referralCode,
  userFirstName,
  rafOffer,
  trackingReferFriendSocialSharing,
  trackUserFreeFoodLinkShare,
) => {
  trackingReferFriendSocialSharing(actionTypes.REFER_FRIEND_LINK_SHARE, 'ReferFriendLink Share', SOCIAL_TYPES.whatsapp)
  trackUserFreeFoodLinkShare({ target: SOCIAL_TYPES.whatsapp })

  const whatsappUTM = '&utm_source=whatsapp&utm_medium=sharebutton_raf_page&utm_campaign=raf_whatsapp_share'
  const referralLink = getReferralLink(referralCode, userFirstName, whatsappUTM)
  const message = getMessage(rafOffer)
  const encodedMessage = encodeURIComponent(`${message}\r\n${referralLink}`)

  return window.location.assign(`https://api.whatsapp.com/send?text=${encodedMessage}`)
}

export const getTextMessageReferralLink = (
  referralCode,
  userFirstName,
  rafOffer,
  trackingReferFriendSocialSharing,
  trackUserFreeFoodLinkShare,
) => {
  trackingReferFriendSocialSharing(actionTypes.REFER_FRIEND_LINK_SHARE, 'ReferFriendLink Share', SOCIAL_TYPES.text)
  trackUserFreeFoodLinkShare({ target: SOCIAL_TYPES.text })

  const textMessageUTM = '&utm_source=text_message&utm_medium=sharebutton_raf_page&utm_campaign=raf_text_message_share'
  const referralLink = getReferralLink(referralCode, userFirstName, textMessageUTM)
  const message = getMessage(rafOffer)
  const encodedMessage = encodeURIComponent(`${message}\r\n${referralLink}`)

  return window.location.assign(`sms:?&body=${encodedMessage}`)
}

